import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import { Input,TreeSelect } from 'antd'

import { Page,Crud } from '../../components'

const {CrudTable,CrudForm,CrudFilter,CrudButtons} = Crud

export class UserTagPage extends Component {
  static propTypes = {
    system: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount(){
     const { userTagPage,currentUserTag} = this.props.system;
     const {getAllUserTag} = this.props.actions;
     getAllUserTag();
     this.fetchList( userTagPage);
  }

  fetchList = (page,values) => {
    const {getUserTagList} = this.props.actions;
    let params = Object.assign({},{page:page},values)
    getUserTagList(params);
  }

  getDataSource() {
    const { system } = this.props;
    const { userTagById, userTagList } = system;
    if (!userTagList) return [];
    return userTagList.map(id => userTagById[id]);
  }

  get listProps() {
    const { system,actions } = this.props
    const { getUserTagListPending,userTagTotal,userTagPage,originUserTagTree,userTagTree } = system
    const { deleteUserTag,chooseCurrentUserTag,userTagModalChange } = actions;

    return {
      dataSource: originUserTagTree,
      loading: getUserTagListPending,
      columns:[
        {
          title: "用户标签",
          dataIndex: 'name',
          key: 'name',
          align:'left',
          width: 180,
        },
        {
          title: "排序号",
          dataIndex: 'orderNum',
          key: 'orderNum',
          align:'left',
          width: 180,
        },
      ],
      pagination:undefined,
      op:[
       {
          key:1,
          name:'编辑',
          buttonProps:{
            icon:"edit",
            type:"primary"
          },
        },
        {
          key:3,
          name:'删除',
          buttonProps:{
            icon:"delete",
            type:"danger"
          },
          needConfirm:true,
          confirmTitle:"确认删除"
        }
      ],
      handleMenuClick: (record,item) => {
        if (item.key == 1){
          chooseCurrentUserTag(record);
          userTagModalChange(true,"updata");
        }else if(item.key == 3){
            deleteUserTag(record.id).then((data) => {
            this.fetchList(userTagPage);
          })
        }
      }
    }
  } 

  get modalProps() {
    const { system,actions } = this.props
    const { currentUserTag, userTagModalVisible,userTagPage, userTagModalType,submitUserTagPending,userTagTree } = system

    const { userTagModalChange,submitUserTag,getAllUserTag } = actions;
    const editItem  = userTagModalType === 'create' ? {} : currentUserTag
    return {
      item: userTagModalType === 'create' ? {} : currentUserTag,
      visible: userTagModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submitUserTagPending,
      title: `${
        userTagModalType === 'create' ? `创建` : `更新`
      }`,
      centered: true,
      elements: [
        {
            key: "pid",
            label: "父级",
            initialValue: editItem.pid,
            widget: TreeSelect,
            widgetProps:{
                treeData:userTagTree,
                treeDefaultExpandAll:false,
                onChange:this.onChange,
            },
            required: false
        },
        {
          key: "name",
          label: "用户标签",
          initialValue: editItem.name,
          widget: Input,
          required: true
        },
        {
          key: "orderNum",
          label: "排序号",
          initialValue: editItem.orderNum,
          widget: Input,
          required: true
        },
      ],
      onOk: data => {
        submitUserTag(Object.assign({},data,{})).then(data=> {
          userTagModalChange(false,"create");
          getAllUserTag();
          this.fetchList(userTagPage);
        })
      },
      onCancel() {
        userTagModalChange(false,"create");
      },
    }
  }

  get filterProps() {
    const { actions,system } = this.props
    const { currentUserTag,userTagPage} = system
    const { userTagModalChange } = actions;

    return {
      title:"",
      searchElements: [
        {
            key: "name",
            widget: Input,
            widgetProps:{
                placeholder:"请输入用户标签"
            },
        },
      ],
      onFilterChange: value => {
         this.fetchList(1,value)
      },
      onAdd() {
        userTagModalChange(true,'create')
      },
    }
  }

  get buttonProps() {
    const { actions,system } = this.props
    const { currentUserTag,userTagPage} = system
    const { userTagModalChange } = actions;

    return {
        buttons:[
            {
                name:"新增",
                buttonProps:{
                    type:"primary",
                    icon:"plus",
                },
                onClick:()=>{ userTagModalChange(true,'create')}
            }
        ]
    }
  }

  render() {
    return (
      <Page inner>
        {/* <CrudFilter {...this.filterProps} /> */}
        <CrudButtons {...this.buttonProps} />
        <CrudTable {...this.listProps} />
        <CrudForm {...this.modalProps} />
      </Page>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    system: state.system,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserTagPage);


// WEBPACK FOOTER //
// ./src/features/system/UserTagPage.js